export const Headeroptions = [
  { heading: 'Profile', path: '/members/profile' },
  { heading: 'Connections', path: '/members/connection' },
  { heading: 'Log', path: '/members/log' },
];

export const MemberTypes = { ALL: 'ALL', ACTIVE: 'is_active' };
